// @flow
export const FLAGS_TOGGLE = 'flags/TOGGLE';

export function toggleFlag(flag: string, state: boolean) {
  return (dispatch, getState) => {
    dispatch({
      type: FLAGS_TOGGLE,
      flag,
      state: state !== undefined ? state : !getState()['flags'][flag],
    });
  };
}



// WEBPACK FOOTER //
// ./actions/flags.js